export const internalToolsRouteNames = {
   FEATURE_FLAGS: 'feature-flags',
   AUTH_USERS: 'auth-users',
   ORGANIZATIONS: 'organizations',
   FAQS: 'faqs',
};
